import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jfst(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
 <title>Master the Art of Java First Program: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java java first program tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java first program,first program of java,java program for depth first search,java program to display first 50 prime numbers,my first java program hello world,java program capitalize first letter word,java first programming language" />
<link rel="canonical" href="https://www.codeexampler.com/java-first-program" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java basic programming<br/></h1>
    <div className="first">
        <a href="/java-keywords">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">java first program and How Java works:</h2><br/>
    

    

<h2 className="headings">Java Basic Syntax: </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-7">Access </span>
            <span className="qwerty">modifier </span>
            <span className="qwerty-10">class</span>
            <span className="qwerty-4"> className</span>

            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;body1</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


    
<h2 className="headings">Q-Write a basic Program java Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> First_Program </span>
          <span className="qwerty-5">{`//class is a keyword`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      
          {"\n"}
 
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Java First program or Hello World "</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
 <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This is Java First program or Hello World </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


    <h2 className="mt-4 mh2">First program or basics java program in the following steps:
</h2>
    <p className="mt-4 para">1, firstly the name of the source file  should be  an: <span className="bold">basis_example.java</span><br/>
2, The Java compiler requires that the source file use. Java filename extension. <br/>
3, After going inside the program <br/>
4, Write a class keyword to declare a new class <br/>
5, Basis_example is an identifier, and also this is the name of the class<br/>
6, Inside this class, we create a body between the opening curly braces(&#123;) and close by curly braces( &#125; ).<br/>
7, This is an essential line in the java program <br/>
<span className="bold">Public static void main(string args[]) </span><br/>
8, The public is access –modifier keyword. The public allows the program to control the visibility of class members.<br/>
9, Static is also a keyword .static keyword by the use of JVM call  directly main () method without creating any object  means no need to create an object<br/>
10, Void  is also a keyword, and the role of the Void is that compile main() without return a value<br/>
<span className="bold">Main()</span> <br/>
*This is a pre-defined method.<br/>
*String is also a class.<br/>
*String is used with the main method because the string is immutable and  other thing is that all programming processes in the form of string<br/>
11, Args is an argument<br/>
12, In the next line:<br/>
13, The system is a pre-defined class that provides access to the system<br/>
14, Out this is the output stream  that is connected  to the console<br/>
15, We show output by the use of the println() method. Println() display the string which is passed to it<br/>


</p>
    
  
  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-keywords">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jfst;